import { getNoticeUnreadCount } from '@/api';
import store from '@/store';
import { connectNoticeWebSocket, disconnectNoticeWebSocket } from './noticeWebSocket';

// 拉取未读消息数量
export async function fetchNoticeUnreadCount() {
  if (!store.state.token) {
    store.commit('setNoticeUnreadCount', 0);
    return 0;
  }
  try {
    const res = await getNoticeUnreadCount();
    const count = res?.data?.data?.unread_count ?? 0;
    store.commit('setNoticeUnreadCount', count);
    return count;
  } catch {
    return store.state.noticeUnreadCount;
  }
}

let isConnected = false;

// 初始化站内信：未读数 + WebSocket
export function initNoticeService(vueInstance) {
  if (!store.state.token) return;

  fetchNoticeUnreadCount();

  if (isConnected) return;
  isConnected = true;

  connectNoticeWebSocket((data) => {
    // console.log('站内信 WebSocket 收到新消息', data);
    // 收到新消息时弹出提示:type=connection时，不弹出提示; type=unread时，弹出提示; 其他类型，不弹出提示
    if (data?.type === 'connection') return;
    if (data?.type === 'unread_messages') {
      const unread_messages_count = data?.count || 0;
      const title = vueInstance.$t('notice.unreadMessage', { count: unread_messages_count });
      // 消息内容在data.messages中，暂未处理
      vueInstance.$message({
        message: title,
        type: 'info',
        duration: 5000,
      });
    }

    if (data?.type === 'message') {
      const title = vueInstance.$t('notice.newMessage');
      // 消息内容在data.messages中，暂未处理
      vueInstance.$message({
        message: title,
        type: 'info',
        duration: 5000,
      });
    }

    // 更新未读数
    fetchNoticeUnreadCount();

    // 若消息弹窗已打开则刷新列表
    vueInstance.$root.$emit('notice-list-refresh');
  });
}

// 销毁站内信服务
export function destroyNoticeService() {
  isConnected = false;
  disconnectNoticeWebSocket(true);
  store.commit('setNoticeUnreadCount', 0);
}
